<template>
  <div id="content" class="openDetailBox">
    <div class="lessonName">{{lessonName}}</div>
    <div class="backdetail" @click="backOpenList()">
      <Icon type="ios-arrow-back" />返回</div>
    <div class="lessonbox">
      <div class="videoPlayer" id="videoPlayer"></div>
      <div class="lesListBox">
        <div class="courseList">课程目录</div>
        <div class="lesListBoxCon">
          <div v-if="lessonLectureList.length != 0">
            <Collapse v-model="value">
              <Panel v-for="(n,m) in lessonLectureList" :key="m" :name="m+1+''" :title="n.name">
                {{n.name}}
                <div slot="content">
                  <div class="videoOpenBox">
                    <div v-for="(k,l) in n.jyxtSectionList" :key="l" @click="playVideo(k.ccid,k.id,k.name)" :class=" ccid == k.ccid?'active videocon':'videocon'" :title="k.name">
                      <Icon type="logo-youtube" />{{k.name}}</div>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
          <div v-else-if="lessonChapterList.length != 0">
            <Collapse v-model="value">
              <Panel v-for="(item,index) in lessonChapterList" :key="index" :name="index+1+''">
                {{item.name}}
                <div slot="content">
                  <Collapse v-model="value1">
                    <Panel v-for="(n,m) in item.jyxtLectureList" :key="m" :name="index+1+'-'+m+1">
                      {{n.name}}
                      <div slot="content">
                        <div class="videoOpenBox">
                          <div v-for="(k,l) in n.jyxtSectionList" :key="l" @click="playVideo(k.ccid,k.id,k.name)" :class=" ccid == k.ccid?'active videocon':'videocon'">
                            <Icon type="logo-youtube" />{{k.name}}</div>
                        </div>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>

      </div>
    </div>
    <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
  </div>
</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  import cookie from '../../assets/getCookie.js';
  import message from '../Message/Message'
  export default {
    name: 'OpenDetail',
    props: {
      lessonTest: {
        type: Object,
        default: {
          isOpen: false
        }
      }
    },
    data() {
      return {
        urlHttp: '/testIp',
        value: '1',
        value1:'1-1',
        ccid: null,
        resourceData:{videoId:null,videoName:null},
        videoId:null,
        videoName:null,
        lessonChapterList: [],
        lessonLectureList: [],
        imgurl: 'https://www.aixuetang.com/pic', //微课图片地址  线上域名
        lessonId: null,
        indexOpen: null,
        lessonName: '',
        isShowMessage: false,
        msg: null,
        videoObject: {
          vid: '',
          siteid: '3BF7C9738A6F67BC',
          mediatype: 1,
          autoStar: false,
          width: "100%",
          height: "100%",
          isShare: 'true',
          parentNode: '#videoPlayer'
        }
      }
    },
    watch: {
      videoObject: {
        handler: function(newVal,oldVal) {
          //console.log(newVal)
          new createCCH5Player(this.videoObject);
        },
        deep: true
      }
    },
    mounted() {
      new createCCH5Player(this.videoObject);
      const that = this;
      bus.$off('lessonId');
      bus.$on('lessonId', function(msg) {
        // console.log(msg)
        that.lessonId = msg;
        that.getOpenDataList(that.lessonId);
      })
      if (this.lessonTest.isOpen == true) {
        that.getOpenDataList(this.lessonTest.lessonId);
      }
      // bus.$off('indexOpen');
      // bus.$on('indexOpen', function(msg) {
      //   console.log(msg)
      //   that.indexOpen = msg;
      //   that.getOpenDataList(that.indexOpen.lessonId);
      // })
      this.$nextTick(()=>{
        $(document).scrollTop(0);
      })
    },
    methods: {
      //获取公开课程列表
      getOpenDataList(id) {
        const that = this;
        const result = [];
        const url = '/axt-crm/jyxtCourse/getJyxtCourseDetail?course_id=' + id;
        api.getListAPI(url).then(res => {
          console.log(res.data,"ppppppp")
          if (res.data.message == 'success') {
            that.lessonList = res.data.data;
            that.lessonChapterList = res.data.data.jyxtChapterList;
            that.lessonLectureList = res.data.data.jyxtLectureList;
            if (that.lessonChapterList.length == 0) {
              that.videoObject.vid = that.lessonLectureList[0].jyxtSectionList[0].ccid;
              that.ccid = that.lessonLectureList[0].jyxtSectionList[0].ccid;
              that.videoId = that.lessonLectureList[0].jyxtSectionList[0].id;
              that.videoName = that.lessonLectureList[0].jyxtSectionList[0].name;
            } else {
              that.videoObject.vid = that.lessonChapterList[0].jyxtLectureList[0].jyxtSectionList[0].ccid;
              that.ccid = that.lessonChapterList[0].jyxtLectureList[0].jyxtSectionList[0].ccid;
              that.videoId = that.lessonChapterList[0].jyxtLectureList[0].jyxtSectionList[0].id;
              that.videoName = that.lessonChapterList[0].jyxtLectureList[0].jyxtSectionList[0].name;
            }
            that.lessonName = res.data.data.name;
            //console.log(that.lessonList, 'lessonList')
          }
        })
      },
      playVideo(ccid,id,videoname) {
        let that = this;
        let websiteid = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_' + websiteid + '_access_token')
        if(that.ccid != ccid){
          if (!cookie_token) {
            this.isShowMessage = true;
            this.msg = '查看本节课程请登录！';
            return
          }
         }
        that.ccid = ccid;
        that.videoObject.vid = ccid;
        this.addRecord();
        that.videoId = id;
        that.videoName = videoname;
      },
      isShowMsg(msg) {
        this.isShowMessage = false;
      },
      backOpenList() {
        this.addRecord();
        this.$emit('isBack', false);
      },
      addRecord() {
        let userType = localStorage.getItem('userType');
        var url = '';
        const time = window.cc_js_Player.getPosition();
        const params = {
              resourceId:this.videoId,
              resourceName: this.videoName,
              resourceSource:2,
              operateAccess:3,
              userId:localStorage.getItem('userId'),
              operateDuration:time
          }
        if (userType == 'teacher') {
          url = '/axt-statistics/statistics_teacher/addRecord';
          params.operateTypeId = 10;
          params.resourceType = 1;
        }else {
          url =  '/axt-statistics/statistics_student/addRecord';
          params.operateTypeId = 11;
        }
        if(time >0){
          api.postFormAPI(url,params).then(res => {
              console.log(res)
          })
        }
      }
    },
    components: {
      message
    }
  }
</script>
<style lang="">
  .openDetailBox {
    position: relative;
    min-height: 710px;
  }

  .openDetailBox .backdetail {
    float: right;
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 14px;
    z-index: 10;
    cursor: pointer;
  }

  .openDetailBox .backdetail:hover {
    color: #2d8cf0;
  }

  .openDetailBox .lessonName {
    font-size: 26px;
    height: 40px;
    text-align: left;
    margin: 15px 0;
  }

  .openDetailBox .lessonbox {
    display: flex;
    flex-direction: row;
    height: 600px;
  }

  .openDetailBox .lessonbox #videoPlayer {
    flex: 9;
    height: 600px !important;
  }

  .openDetailBox .lessonbox .lesListBox {
    flex: 3;
    height: 600px;
    background-color: #575859;
    text-align: left;
  }
  .lesListBoxCon {
    height: 534px;
    overflow: hidden;
    overflow-y: auto;
  }
  .openDetailBox .lessonbox .lesListBoxCon::-webkit-scrollbar {
    width: 4px;
    /*height: 4px;*/
  }

  .openDetailBox .lessonbox .lesListBoxCon::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .openDetailBox .lessonbox .lesListBoxCon::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);

  }

  .openDetailBox .videoOpenBox .videocon {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #E2E3E3;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
  }

  .lesListBox .ivu-collapse {
    border: none;
  }

  .lesListBox .ivu-collapse-content {
    background: #2D2D2D !important;
  }

  .lesListBox .ivu-collapse-header {
    background-color: #454647 !important;
    color: #E2E3E3 !important;
  }

  .openDetailBox .videoOpenBox .videocon.active {
    color: #3583FF;
  }

  .openDetailBox .videoOpenBox .ivu-icon-logo-youtube {
    margin-right: 20px;
  }

  .openDetailBox .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
    border-bottom: 1px solid #575859;
  }
  .lesListBox .ivu-collapse>.ivu-collapse-item {
     border-top: none;
  }
  .courseList {
    width: 100%;
    font-size: 18px;
    color: #fff;
    background-color: #3583FF;
    height: 66px;
    line-height: 66px;
    text-align: center;
    cursor: default;
  }
  .lesListBoxCon .ivu-icon-ios-arrow-forward:before {
    content: "\F33D";
  }
  .lesListBoxCon .ivu-collapse>.ivu-collapse-item >.ivu-collapse-header {
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  .lesListBoxCon .ivu-collapse>.ivu-collapse-item.ivu-collapse-item-active>.ivu-collapse-header>i {
    transform: rotate(-180deg);
  }
</style>



// WEBPACK FOOTER //
// src/components/OpenDetail/OpenDetail.vue